import HEADER from '../header.vue'
export default {
  data() {
    return {
      menuCurrentList: [],
      dasyncWidth: this.$store.state.menu.isCollapse,
      count: [0, 1, 2],
      transitionName: 'slide'
    }
  },
  components: {
    HEADER
  },
  created() {
    this.menuCurrentList = this.$route.matched
  },
  computed: {
    isFollow() {
      return this.$route.matched // 需要监听的数据
    },
    dasyncWidthFun() {
      return this.$store.state.menu.isCollapse
    }
  },
  watch: {
    isFollow(newVal, oldVal) {
      this.menuCurrentList = newVal
    },
    $route(to, from) {
      this.$Loading.start()
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide' : 'fade'
      this.$Loading.finish()
    },
    dasyncWidthFun(newVal, oldVal) {
      this.dasyncWidth = newVal
    }
  },
  methods: {
    handleAdd() {
      if (this.count.length) {
        this.count.push(this.count[this.count.length - 1] + 1)
      } else {
        this.count.push(0)
      }
    },
    handleClose2(event, name) {
      const index = this.count.indexOf(name)
      this.count.splice(index, 1)
    }
  }
}
